export default {"src":"/_next/static/media/adobe-xd.f0c5ce4c.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};